export default "__VITE_ASSET__CuTphXRG__"